import { render, staticRenderFns } from "./home-client.vue?vue&type=template&id=38b4643b&scoped=true"
import script from "./home-client.vue?vue&type=script&lang=js"
export * from "./home-client.vue?vue&type=script&lang=js"
import style0 from "./home-client.vue?vue&type=style&index=0&id=38b4643b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4643b",
  null
  
)

export default component.exports